export default "__VITE_ASSET__B5CZTP9A__"